"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _typeGuards = require("../../libs/typeGuards");

var _AiLogo = _interopRequireDefault(require("@insided/destination/icons/AiLogo"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _algolia = require("@insided/shared/services/algolia");

var _AutoSuggestTags = _interopRequireDefault(require("./AutoSuggestTags"));

var _common = require("@insided/shared/utils/common");

var _preact2 = _interopRequireDefault(require("downshift/preact"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _algoliaService = require("../../services/algoliaService");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("@insided/destination/modules/Search/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'public-tag-select';
exports.cssAnchorName = cssAnchorName;

var PublicTagSelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PublicTagSelect, _Component);

  var _super = _createSuper(PublicTagSelect);

  function PublicTagSelect() {
    var _this$props$selectedP;

    var _this;

    (0, _classCallCheck2.default)(this, PublicTagSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tagInput", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropDown", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectedTagNames", (_this$props$selectedP = _this.props.selectedPublicTags) !== null && _this$props$selectedP !== void 0 && _this$props$selectedP.length ? _this.props.selectedPublicTags.map(function (t) {
      return {
        name: t
      };
    }) : []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectedTagsSet", new Set(_this.selectedTagNames.map(function (t) {
      return t.name.toLowerCase();
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      publicTagList: [],
      aiTagList: [],
      selectedPublicTags: (0, _toConsumableArray2.default)(_this.selectedTagNames),
      selectedTagsSet: _this.selectedTagsSet,
      searchText: '',
      content: '',
      title: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cb", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
        var client, communityId;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _algolia.createAlgoliaClient)(data.client_id, data.token);

              case 2:
                client = _context.sent;
                communityId = (0, _utils.getCommunityId)();

                if (_common.common.isModuleActive('unifiedIndexEnabled')) {
                  _this.setState({
                    index: client.initIndex(communityId)
                  });
                } else {
                  _this.setState({
                    index: client.initIndex("".concat(communityId, "-tags"))
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setContentListener", function () {
      var _document$querySelect;

      var isTitleDirty = false;
      var isDescriptionDirty = false;
      var contentIframe = document.querySelector('.cke_wysiwyg_frame');

      if (contentIframe) {
        var _contentIframe$conten, _contentIframe$conten2;

        var iframeDocument = (_contentIframe$conten = contentIframe.contentDocument) !== null && _contentIframe$conten !== void 0 ? _contentIframe$conten : (_contentIframe$conten2 = contentIframe.contentWindow) === null || _contentIframe$conten2 === void 0 ? void 0 : _contentIframe$conten2.document;

        if (iframeDocument) {
          var _iframeDocument$query;

          (_iframeDocument$query = iframeDocument.querySelector('.post__content--new-editor')) === null || _iframeDocument$query === void 0 ? void 0 : _iframeDocument$query.addEventListener('blur', function (e) {
            var _e$target;

            var _this$state = _this.state,
                content = _this$state.content,
                title = _this$state.title; // @ts-expect-error-error

            var newContent = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.innerHTML;
            var isContentEmpty = newContent === '' || newContent === '<p><br></p>';

            if (!isContentEmpty && content !== newContent) {
              isDescriptionDirty = true;

              if (isTitleDirty) {
                _this.fetchAISuggestedTags({
                  content: newContent,
                  title: title
                });
              }

              _this.setState({
                content: newContent
              });
            }
          });
        }
      }

      (_document$querySelect = document.querySelector('#topic_title')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.addEventListener('blur', function (e) {
        var _e$target2;

        var _this$state2 = _this.state,
            content = _this$state2.content,
            title = _this$state2.title;
        var newTitle = (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value;

        if (newTitle !== '' && title !== newTitle) {
          isTitleDirty = true;

          if (isDescriptionDirty) {
            _this.fetchAISuggestedTags({
              content: content,
              title: newTitle
            });
          }

          _this.setState({
            title: newTitle !== null && newTitle !== void 0 ? newTitle : ''
          });
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchAISuggestedTags", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var params,
          selectedPublicTags,
          _yield$axios$post,
          data,
          firstTwoAiTags,
          newSelectedPublicTags,
          selectedTagsSet,
          _args2 = arguments;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              selectedPublicTags = _this.state.selectedPublicTags;
              _context2.next = 4;
              return _axios.default.post('/topic/suggest-tags', params);

            case 4:
              _yield$axios$post = _context2.sent;
              data = _yield$axios$post.data;
              firstTwoAiTags = data.tags.slice(0, 2);
              firstTwoAiTags = firstTwoAiTags.filter(function (aiTag) {
                return !selectedPublicTags.find(function (tag) {
                  return tag.name.toLowerCase() === aiTag.name.toLowerCase();
                });
              });
              newSelectedPublicTags = [].concat((0, _toConsumableArray2.default)(selectedPublicTags), (0, _toConsumableArray2.default)(firstTwoAiTags));
              selectedTagsSet = new Set(newSelectedPublicTags.map(function (t) {
                return t.name.toLowerCase();
              }));

              _this.setState({
                selectedPublicTags: newSelectedPublicTags,
                aiTagList: data.tags.slice(0, 5),
                selectedTagsSet: selectedTagsSet
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refreshSuggestions", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(searchText) {
        var _this$state$index;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                (_this$state$index = _this.state.index) === null || _this$state$index === void 0 ? void 0 : _this$state$index.search({
                  restrictSearchableAttributes: ['name'],
                  query: searchText,
                  filters: _common.common.isModuleActive('unifiedIndexEnabled') ? 'gs_data_source:tags' : undefined
                }).then(function (_ref4) {
                  var _this$tagInput;

                  var hits = _ref4.hits;
                  var aiTagList = _this.state.aiTagList;
                  var filteredAiTagList = aiTagList.filter(function (aiTag) {
                    return aiTag.name.toLowerCase().includes(searchText);
                  });

                  _this.setState({
                    publicTagList: [].concat((0, _toConsumableArray2.default)(filteredAiTagList), (0, _toConsumableArray2.default)(hits)),
                    searchText: searchText
                  });

                  (_this$tagInput = _this.tagInput) === null || _this$tagInput === void 0 ? void 0 : _this$tagInput.focus();
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isTagSelected", function (tag) {
      return _this.state.selectedTagsSet.has(tag.toLowerCase());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectPublicTag", function (tag) {
      var remainFocusOnInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$state3 = _this.state,
          selectedPublicTags = _this$state3.selectedPublicTags,
          selectedTagsSet = _this$state3.selectedTagsSet;

      if (_this.isTagSelected(tag.name)) {
        return;
      }

      selectedTagsSet.add(tag.name.toLowerCase());
      selectedPublicTags.push(tag);

      _this.setState({
        selectedPublicTags: selectedPublicTags,
        selectedTagsSet: selectedTagsSet,
        searchText: ''
      });

      if (_this.props.onChange) {
        _this.props.onChange(selectedPublicTags.map(function (t) {
          return t.name;
        }));
      }

      if (remainFocusOnInput) {
        _this.refreshSuggestions('');
      }
    });
    return _this;
  }

  (0, _createClass2.default)(PublicTagSelect, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _this2 = this,
            _this$state$index2;

        var _this$props, showAITags, canEndUserAddPublicTags, aiFeatures, suggestAiTags;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props = this.props, showAITags = _this$props.showAITags, canEndUserAddPublicTags = _this$props.canEndUserAddPublicTags;
                aiFeatures = _common.common.isModuleActive('aiFeatures');
                suggestAiTags = _common.common.isModuleActive('suggestAiTags');

                if (aiFeatures && suggestAiTags && showAITags && canEndUserAddPublicTags) {
                  setTimeout(function () {
                    _this2.setContentListener();
                  }, 3000);
                }

                _context4.next = 6;
                return (0, _algoliaService.getSearchToken)(this.cb);

              case 6:
                (_this$state$index2 = this.state.index) === null || _this$state$index2 === void 0 ? void 0 : _this$state$index2.search({
                  query: '',
                  filters: _common.common.isModuleActive('unifiedIndexEnabled') ? 'gs_data_source:tags' : undefined
                }).then(function (_ref5) {
                  var hits = _ref5.hits;

                  _this2.setState({
                    publicTagList: (0, _toConsumableArray2.default)(hits)
                  });
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedPublicTags !== prevProps.selectedPublicTags) {
        var _this$props$selectedP2;

        var selectedTagNames = (_this$props$selectedP2 = this.props.selectedPublicTags) !== null && _this$props$selectedP2 !== void 0 && _this$props$selectedP2.length ? this.props.selectedPublicTags.map(function (t) {
          return {
            name: t
          };
        }) : [];
        var selectedTagsSet = new Set(selectedTagNames.map(function (t) {
          return t.name.toLowerCase();
        }));
        this.setState({
          selectedPublicTags: selectedTagNames,
          selectedTagsSet: selectedTagsSet
        });
      }
    }
  }, {
    key: "updateSearchText",
    value: function updateSearchText(e) {
      if (e.code === 'Escape') {
        var _this$tagInput2;

        (_this$tagInput2 = this.tagInput) === null || _this$tagInput2 === void 0 ? void 0 : _this$tagInput2.blur();
        return;
      }

      var target = e === null || e === void 0 ? void 0 : e.target;

      if (!(0, _typeGuards.isInputEl)(target)) {
        return;
      }

      var value = target.value;

      if (e.code === 'Backspace' && !this.state.searchText.length) {
        this.removeLastTag();
      }

      this.refreshSuggestions(value);
    }
  }, {
    key: "removeLastTag",
    value: function removeLastTag() {
      var selectedPublicTags = this.state.selectedPublicTags;

      if (!selectedPublicTags.length) {
        return;
      }

      var lastSelected = selectedPublicTags[selectedPublicTags.length - 1];
      this.removePublicTag(lastSelected);
      this.refreshSuggestions('');
    }
  }, {
    key: "removePublicTag",
    value: function removePublicTag(tag) {
      var _this$state4 = this.state,
          selectedPublicTags = _this$state4.selectedPublicTags,
          selectedTagsSet = _this$state4.selectedTagsSet;

      if (!this.isTagSelected(tag.name)) {
        return;
      }

      selectedTagsSet.delete(tag.name.toLowerCase());
      var index = selectedPublicTags.indexOf(tag);
      selectedPublicTags.splice(index, 1);

      if (this.props.onChange) {
        this.props.onChange(selectedPublicTags.map(function (t) {
          return t.name;
        }));
      }

      this.setState({
        selectedPublicTags: selectedPublicTags,
        selectedTagsSet: selectedTagsSet
      });
    }
  }, {
    key: "handleFocusChange",
    value: function handleFocusChange(openMenu, inputValue) {
      this.refreshSuggestions(inputValue);
      openMenu();
    }
  }, {
    key: "onCancelEditPublicTags",
    value: function onCancelEditPublicTags() {
      var _this$props$selectedP3;

      var selectedTagNames = (_this$props$selectedP3 = this.props.selectedPublicTags) !== null && _this$props$selectedP3 !== void 0 && _this$props$selectedP3.length ? this.props.selectedPublicTags.map(function (t) {
        return {
          name: t
        };
      }) : [];
      var selectedTagsSet = new Set(selectedTagNames.map(function (t) {
        return t.name.toLowerCase();
      }));
      this.setState({
        selectedPublicTags: selectedTagNames,
        selectedTagsSet: selectedTagsSet,
        searchText: ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          isEdit = _this$props2.isEdit,
          inputName = _this$props2.inputName,
          inputId = _this$props2.inputId,
          canEndUserAddPublicTags = _this$props2.canEndUserAddPublicTags,
          iconSize = _this$props2.iconSize,
          placeholder = _this$props2.placeholder,
          fromOldTMPage = _this$props2.fromOldTMPage;
      var _this$state5 = this.state,
          publicTagList = _this$state5.publicTagList,
          selectedPublicTags = _this$state5.selectedPublicTags,
          searchText = _this$state5.searchText;
      var tags = publicTagList.filter(function (tag) {
        return !_this3.isTagSelected(tag.name);
      });
      var tagsField = (0, _preact.h)("input", {
        type: "hidden",
        name: inputName,
        id: inputId,
        value: selectedPublicTags.map(function (t) {
          return t.name;
        }).join(',')
      });

      if (isEdit) {
        tagsField = selectedPublicTags.length ? selectedPublicTags.map(function (tag) {
          return (0, _preact.h)("input", {
            key: "unselected-".concat(tag.name),
            type: "hidden",
            name: inputName,
            value: tag.name
          });
        }) : null;
      }

      var closeIconSize = iconSize !== null && iconSize !== void 0 ? iconSize : 16;

      var isThreadedRepliesEnabled = _common.common.isModuleActive('threadedRepliesDestination');

      return (0, _preact.h)("div", null, (0, _preact.h)(_preact2.default, {
        defaultHighlightedIndex: 0,
        initialHighlightedIndex: 0,
        onChange: function onChange(selection) {
          _this3.selectPublicTag({
            name: selection.name,
            isAI: selection.isAI
          });
        },
        stateReducer: function stateReducer(state, changes) {
          switch (changes.type) {
            case _preact2.default.stateChangeTypes.keyDownEnter:
            case _preact2.default.stateChangeTypes.clickItem:
            case _preact2.default.stateChangeTypes.keyDownEscape:
              return _objectSpread(_objectSpread({}, changes), {}, {
                inputValue: ''
              });

            default:
              return changes;
          }
        },
        itemToString: function itemToString(tag) {
          return tag ? tag.name : '';
        }
      }, function (_ref6) {
        var getInputProps = _ref6.getInputProps,
            getItemProps = _ref6.getItemProps,
            getMenuProps = _ref6.getMenuProps,
            isOpen = _ref6.isOpen,
            openMenu = _ref6.openMenu,
            closeMenu = _ref6.closeMenu,
            inputValue = _ref6.inputValue,
            highlightedIndex = _ref6.highlightedIndex;
        return (0, _preact.h)("div", {
          className: "public-tag-container qa-public-tag-container",
          "aria-expanded": isOpen ? 'true' : 'false'
        }, (0, _preact.h)("div", {
          className: "public-tag-wrapper ".concat(isEdit ? 'public-tag-edit-wrapper' : '')
        }, tagsField, selectedPublicTags.length ? selectedPublicTags.map(function (selected, index) {
          return (0, _preact.h)("div", {
            key: "selected-".concat(selected.name),
            className: (0, _classnames.default)('public-tag_selected-tag', {
              'public-ai-tag': selected.isAI
            }),
            onClick: function onClick() {
              return _this3.removePublicTag(selected);
            },
            role: "button",
            tabIndex: index
          }, (0, _preact.h)("div", {
            className: "public-tag_selected-tag-name"
          }, selected.name), (0, _preact.h)("div", {
            className: "public-tag_selected-remove-button"
          }, (0, _preact.h)(_Close.default, {
            width: closeIconSize,
            height: closeIconSize,
            fill: "currentColor"
          })));
        }) : null, (0, _preact.h)("div", {
          className: "".concat(fromOldTMPage ? 'oldtm-public-tag-input-wrapper' : 'public-tag-input-wrapper')
        }, (0, _preact.h)("input", (0, _extends2.default)({
          title: "",
          ref: function ref(input) {
            _this3.tagInput = input;
          },
          className: "form-control",
          placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : (0, _translations.translate)('Forum', 'tags.add'),
          type: "text"
        }, getInputProps({
          onFocus: function onFocus() {
            return _this3.handleFocusChange(openMenu, inputValue);
          },
          onKeyUp: function onKeyUp(e) {
            return _this3.updateSearchText(e);
          }
        }), {
          // has to be outside to overwrite whatever getInputProps would put onBlur
          onBlur: function onBlur() {
            return closeMenu();
          }
        }))), isOpen && (0, _preact.h)("div", {
          className: "public-tag-list-container",
          ref: function ref(element) {
            _this3.dropDown = element;
          }
        }, (0, _preact.h)(DropDown, {
          tags: tags,
          searchText: searchText,
          canEndUserAddPublicTags: canEndUserAddPublicTags,
          isTagSelected: _this3.isTagSelected,
          getMenuProps: getMenuProps,
          getItemProps: getItemProps,
          highlightedIndex: highlightedIndex
        }))), _common.common.isModuleActive('publicTagAutoSuggestion') && _common.common.isModuleActive('publicTagDestination') && (0, _preact.h)(_AutoSuggestTags.default, {
          isTagSelected: _this3.isTagSelected,
          selectPublicTag: _this3.selectPublicTag
        }));
      }), isEdit ? (0, _preact.h)("div", {
        className: "public-tag-edit-buttons"
      }, (0, _preact.h)("button", {
        className: (0, _classnames.default)('btn', 'btn--S', 'qa-button-tags-cancel', isThreadedRepliesEnabled ? 'btn-secondary' : 'btn--cancel'),
        onClick: function onClick() {
          return _this3.onCancelEditPublicTags();
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "Cancel",
        m: "Forum"
      })), (0, _preact.h)("button", {
        className: (0, _classnames.default)('btn', 'btn--S', 'btn--cta', 'save-public-tag', 'qa-button-tags-save'),
        type: "submit"
      }, (0, _preact.h)(_phrase.default, {
        p: "Save",
        m: "Forum"
      }))) : null);
    }
  }]);
  return PublicTagSelect;
}(_preact.Component);

exports.default = PublicTagSelect;

var DropDown = function DropDown(_ref7) {
  var tags = _ref7.tags,
      canEndUserAddPublicTags = _ref7.canEndUserAddPublicTags,
      isTagSelected = _ref7.isTagSelected,
      searchText = _ref7.searchText,
      getMenuProps = _ref7.getMenuProps,
      getItemProps = _ref7.getItemProps,
      highlightedIndex = _ref7.highlightedIndex;
  // eslint-disable-next-line
  var options = [];
  var showCreatePublicTagOption = canEndUserAddPublicTags && !tags.some(function (tag) {
    return tag.name.toLowerCase() === searchText.toLowerCase();
  });

  if (tags.length > 0) {
    var aiTagListLength = tags.filter(function (item) {
      return item.isAI === true;
    }).length;

    if (aiTagListLength > 0) {
      options.push((0, _preact.h)("li", {
        className: "public-ai-tag-list-item"
      }, (0, _preact.h)("span", null, (0, _preact.h)(_AiLogo.default, null)), (0, _preact.h)("span", {
        className: "ai-suggested-tag-header"
      }, "Suggested by AI")));
      options.push.apply(options, (0, _toConsumableArray2.default)(tags.map(function (item, index) {
        var modifiedIndex = showCreatePublicTagOption ? index + 1 : index;
        return item.isAI ? (0, _preact.h)("li", getItemProps({
          key: item.name,
          index: modifiedIndex,
          item: item,
          class: highlightedIndex === modifiedIndex ? 'highlight-selected-option public-tag-list-item' : 'public-tag-list-item'
        }), (0, _preact.h)("span", null, item.name)) : null;
      })));
      options.push((0, _preact.h)("hr", {
        className: "public-ai-tag-list-separator"
      }));
    }

    options.push.apply(options, (0, _toConsumableArray2.default)(tags.map(function (item, index) {
      var modifiedIndex = showCreatePublicTagOption ? index + 1 : index;
      return !item.isAI && (0, _preact.h)("li", getItemProps({
        key: item.name,
        index: modifiedIndex,
        item: item,
        class: highlightedIndex === modifiedIndex ? 'highlight-selected-option public-tag-list-item' : 'public-tag-list-item'
      }), (0, _preact.h)("span", null, item.name), (0, _preact.h)("span", {
        className: "usage-count"
      }, item.count));
    })));
  } else if (!canEndUserAddPublicTags || !isTagSelected(searchText)) {
    options.push((0, _preact.h)("li", {
      className: "public-tag_not-found"
    }, (0, _preact.h)(_phrase.default, {
      p: "live.search.no.result.found.text",
      m: "Forum"
    }), " ", searchText));
  }

  if (showCreatePublicTagOption) {
    options.unshift((0, _preact.h)(AddNewPublicTag, {
      searchText: searchText,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      isTagSelected: isTagSelected
    }));
  }

  return (0, _preact.h)("ul", getMenuProps(), options);
};

var AddNewPublicTag = function AddNewPublicTag(_ref8) {
  var searchText = _ref8.searchText,
      isTagSelected = _ref8.isTagSelected,
      getItemProps = _ref8.getItemProps,
      highlightedIndex = _ref8.highlightedIndex;

  if (searchText.length === 0) {
    return null;
  }

  if (isTagSelected(searchText)) {
    return (0, _preact.h)("li", {
      className: "public-tag-list-item existing-tag"
    }, (0, _preact.h)(_phrase.default, {
      p: "tags.already.added",
      m: "Forum"
    }));
  }

  return (0, _preact.h)("li", (0, _extends2.default)({
    className: "public-tag-list-item new-tag"
  }, getItemProps({
    key: searchText,
    index: 0,
    item: {
      name: searchText
    },
    class: highlightedIndex === 0 ? 'highlight-selected-option public-tag-list-item new-tag' : 'public-tag-list-item new-tag'
  })), (0, _preact.h)(_phrase.default, {
    p: "tags.add.new",
    m: "Forum"
  }), " '", searchText, "'");
};